import React, { createContext} from "react";

  const ProfileNameContext = React.createContext();
  export default ProfileNameContext;
